import React from 'react';
import { resolveCabinetSchematic } from './CabinetFrame';
import {
  CabinetBackElevation,
  CabinetFrontElevation,
  CabinetSideElevation,
} from './CabinetElevation';

/**
 * Elevation schematic for `lower-cabinet`.
 *
 * Draws exactly what `cabinetRenderer.lowerCabinetRenderer` builds, from the
 * same `cabinetFrontLayout`: the carcass on its recessed toe kick and the
 * front set — full-height doors when the object carries no `columns` (every
 * kitchen base from `buildLowerCabinet`), or per-column doors / drawers /
 * false rail / working drawer / sink apron / farmhouse drop / false panel
 * when it does (vanities, cabinet-run bay overrides). Side views are the
 * depth profile.
 */
export function LowerCabinetSchematic({
  widthMeters: width,
  heightMeters: height,
  depthMeters: depth,
  view = 'front',
  obj = {},
  strokeColor,
  strokeWidth,
}) {
  const { layout, doorStyle, hardwareType, rollOutSlots } =
    resolveCabinetSchematic(obj, { width, height, depth }, false);
  const stroke = { strokeColor, strokeWidth };
  if (view === 'left' || view === 'right') {
    return (
      <CabinetSideElevation
        layout={layout}
        view={view}
        hardwareType={hardwareType}
        {...stroke}
      />
    );
  }
  if (view === 'back') {
    return <CabinetBackElevation layout={layout} {...stroke} />;
  }
  return (
    <CabinetFrontElevation
      layout={layout}
      doorStyle={doorStyle}
      hardwareType={hardwareType}
      rollOutSlots={rollOutSlots}
      {...stroke}
    />
  );
}

LowerCabinetSchematic.supportsSideViews = true;
// A run's back is a finished panel — `CabinetBackElevation` draws it.
LowerCabinetSchematic.supportsBackView = true;
